(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/utils.js');
'use strict';


svs.matchen = svs.matchen || {};
svs.matchen.utils = svs.matchen.utils || {};

svs.matchen.utils.onClickShowGameGuide = function() {
  if (event) {
    event.preventDefault();
  }
  svs.matchen.utils.showGameGuide();

  return false;
};

svs.matchen.utils.showGameGuide = function(selectedTab) {
  svs.components.Modal.show(
    svs.matchen.views.GameGuide,
    { selectedTab: selectedTab ? selectedTab : '' },
    {
      doubleWidth: !svs.core.detect.formfactor.mobile(),
      headerClass: 'matchen-modal-header',
      leftButton: {
        cssClass: 'btn btn-100 btn-transparent-inverted',
        text: 'Stäng',
        visible: true
      },
      rightButton: { visible: false },
      title: 'Spelguide'
    }
  );
};


 })(window);